import { DAY_WIDTH_PX } from './monthlyLayoutConstants';
import { buildMonthlyTrackedPositions } from './buildMonthlyTrackedPositions';
import type { MonthDescriptor, MonthlyTimelineLane } from './types';

export function computeTimelineBodyWidthPx(
  lanes: MonthlyTimelineLane[],
  months: MonthDescriptor[],
  getDayLeftPx: (monthKey: string, day: number) => number | null,
  totalColumns: number
): number {
  const baseWidth = Math.max(totalColumns * DAY_WIDTH_PX, 0);
  let maxRightPx = baseWidth;

  lanes.forEach(lane => {
    buildMonthlyTrackedPositions({
      items: lane.items,
      months,
      getDayLeftPx,
      laneLabel: lane.label
    }).forEach(entry => {
      maxRightPx = Math.max(maxRightPx, entry.leftPx + entry.widthPx);
    });
  });

  return maxRightPx;
}
